import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-hawaii-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./hawaii-state-form.component.html",
  styleUrl: "./hawaii-state-form.component.scss",
})
export class HawaiiStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
